export default __webpack_public_path__ + "static/media/gm-awc-girl.f0d074d7.webp";